module.exports = __webpack_public_path__ + "img/sucaiavatar.3872c8bf.png";